import React from 'react';
import { CTAButton } from './CTAButton';
import { plans } from '../data/content';
export function PricingSection() {
  return <section id="precios" className="w-full bg-ink-800 px-4 py-14 sm:px-5 sm:py-20" data-id="element-163" data-mp="19jxenin1zhdz">
      <div className="mx-auto max-w-4xl text-center" data-id="element-164" data-mp="1eh79xex4in9q">
        <h2 className="text-2xl font-extrabold uppercase text-white sm:text-4xl" data-id="element-165" data-mp="1j8yrx127rko9">
          💰 Elegí tu sistema
        </h2>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-166" data-mp="1nb26hyk6j5dr">
          {plans.map(plan => <article key={plan.name} className={`relative flex flex-col rounded-3xl border p-6 text-left sm:p-7 ${plan.featured ? 'border-brand-500 bg-ink-900 shadow-[0_0_45px_rgba(249,115,22,0.25)]' : 'border-white/10 bg-ink-900'}`} data-id="element-167" data-mp="1s93zbb7eqj2f">
              {plan.featured && <span className="absolute -top-3 left-6 rounded-full bg-brand-500 px-3 py-1 text-[10px] font-extrabold uppercase tracking-widest text-ink-900" data-id="element-168" data-mp="7tsbbz5c6g93">
                  ⭐ Más elegido
                </span>}
              <h3 className="text-base font-extrabold text-white sm:text-lg" data-id="element-169" data-mp="1hpog41902jfq">
                <span aria-hidden="true" data-id="element-170" data-mp="1cqlmre2du1nl">{plan.icon}</span> {plan.name}
              </h3>
              <p className="mt-3 text-sm text-gray-300" data-id="element-171" data-mp="17rsatq2quipj">{plan.includes}</p>
              <p className="mt-2 text-sm text-gray-400" data-id="element-172" data-mp="17pp948s8b14z">
                <span className="font-semibold text-brand-500" data-id="element-173" data-mp="25ehhwecazli9">Ideal para:</span>{' '}
                {plan.idealFor}
              </p>

              <p className="mt-6 text-sm font-semibold text-gray-500 line-through" data-id="element-174" data-mp="20h8v20g7mtao">
                Valor real: {plan.oldPrice}
              </p>
              <p className="text-3xl font-extrabold text-brand-500 sm:text-4xl" data-id="element-175" data-mp="1rgasznpc0vuq">
                {plan.price}
              </p>

              <div className="mt-auto pt-7" data-id="element-176" data-mp="k2z7h8jsl8kw">
                <CTAButton href={plan.href} variant={plan.featured ? 'primary' : 'outline'} data-id="element-177" data-mp="g0m4grwfjort">
                  {plan.cta}
                </CTAButton>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}